export const DDSFieldIds = {
	ANCHOR_ASSEMBLY: 'ddsAnchorAssembly',
	FRAMING_TYPE: 'ddsFramingType',
	WIRE_UNIT: 'ddsWireUnit',
	JOINT_USE_CABLE: {
		FORM: 'ddsJointUseCable',
		MID_SPAN_HEIGHT: 'ddsJointUseCableMidSpanHeight',
		NAME: 'ddsJointUseCableName',
		OWNER: 'ddsJointUseCableOwner',
		ATTACHMENT_HEIGHT: 'ddsJointUseCableAttachmentHeight',
		MESSENGER: 'ddsJointUseCableMessenger',
	},
} as const;
